/* ══════════════════════════════════════════════════════════════════════════
   skon-quiz-email-content.js — Generatore contenuti HTML email post-quiz
   ──────────────────────────────────────────────────────────────────────────
   Aggiornato: 8 giugno 2026 — 21:50 (Europe/Rome)
   Versione: 2.10.0

   COS'È QUESTO FILE
   ──────────────────────────────────────────────────────────────────────────
   Consumer PURO di window.SkonRoutine. Espone le funzioni che generano
   l'HTML inserito nei campi Magnews del flow email post-quiz:
     - buildE1(routineCode, customer)            → maincontent E1
     - buildProductsHtml(routineCode, customer)  → card prodotti (4 per E1)
     - buildRoutineHtml(routineCode, customer)   → card routine (6 o 5 per E4)

   PRINCIPIO ARCHITETTURALE
   ──────────────────────────────────────────────────────────────────────────
   Tutti i dati prodotto / routine / profilo arrivano da SkonRoutine.get().
   Niente accesso diretto a CATALOG, SKON_TEXTS, SKON_HANDLE_MAP, niente
   duplicazione di logica routine → prodotti. Il consumer riceve solo:
     - routineCode  : 'A1' | 'A2' | ... | 'D9'
     - customer     : { name, age, spfInterest, discountCode, discountPct, isRC }
   E pesca tutto il resto da SkonRoutine.

   PRECONDIZIONI DI CARICAMENTO
   ──────────────────────────────────────────────────────────────────────────
   - window.SkonRoutine deve essere ≥ v1.4.0 (E4 usa `morningRoutine`/`eveningRoutine`;
   -   gli altri builder richiedono `heroProduct`, `imgs[]`,
     `stepLabel`, `category` su prodotti — v1.2.0 — e `getProductById()` —
     v1.3.0, usato per recuperare AK Glow/Matt nelle card "Protezione Solare").
   - Ordine in <head>/<body>: skon-quiz-logic-data.js PRIMA di questo file.
   - Se SkonRoutine non è caricato (race condition improbabile con defer),
     ogni funzione ritorna stringa vuota e logga un warning in console.

   CHANGELOG
   ──────────────────────────────────────────────────────────────────────────
   v2.10.0 (8 giu 2026) — RIMOZIONE SHIM RETROCOMPAT buildE1 (TD-8):
     - REMOVE: rimosso lo shim retrocompatibile in buildE1() che riconosceva
       la vecchia firma object-based ({firstName, profileLetter, desire, age,
       interestSpf, coreIds, ...}) e faceva reverse lookup del routineCode via
       profileLetter + firma coreIds. Era introdotto in v2.0.0 per consentire
       deploy disgiunto da skon-quiz.js v3.0.0 (TD-1).
     - Ora buildE1 accetta ESCLUSIVAMENTE la firma (routineCode, customer).
       Chiamate con la vecchia firma object-based produrranno output errato
       o stringa vuota (no warning specifico — la firma è incompatibile).
     - Param rinominato: routineCodeOrLegacyProfile → routineCode.
     - Deploy ATOMICO con skon-quiz.js v3.0.0 (TD-1): la v3.0.0 chiama TUTTE
       e 3 le funzioni SKON_EMAIL (buildE1/buildProductsHtml/buildRoutineHtml)
       con la firma nuova. Nessuna chiamata legacy residua nel runtime.
     - Output runtime: bit-per-bit identico al pre-rimozione per chiamate con
       la nuova firma (lo shim era solo un dispatcher, la logica reale era
       già post-shim).
   v2.9.0 (6 giu 2026) — LINK SPF CON SCONTO:
     ~ Il link "Scopri la protezione solare Skön ->" ora passa da _buildCtaUrl
       (redirect /discount/CODICE?redirect=/collections/protezione-solare&spw_...)
       come tutte le CTA email: lo sconto viene appligato al clic. Prima era un
       link diretto senza sconto (fix dello stesso giorno).
   v2.8.0 (6 giu 2026) — LINK COLLECTION IN NOTA SPF:
     + Aggiunto link stabile "Scopri la protezione solare Skön ->" in fondo al
       testo SPF, in entrambe le varianti (verde aware / arancione unaware).
       Punta fisso a SPF_COLLECTION_URL (no redirect sconto: è un approfondimento).
   v2.7.0 (6 giu 2026) — RIORDINO BLOCCO SPF:
     ~ Nota SPF spostata DOPO il blocco routine (label prodotti + card), prima
       del box-sconto. Razionale: l'SPF non incide sulla proposta commerciale,
       quindi non sta in cima. Box-sconto resta il sigillo finale. Nessun altro
       contenuto cambiato (solo l'ordine dei blocchi).
   v2.6.0 (6 giu 2026) — RAFFINAMENTI CARD E1 + ICONA SPF:
     ! Testo motivazione eroe spostato DENTRO la card eroe (prima blocco a parte
       sotto). Eyebrow personalizzato "Perché è ideale per te, NOME" (era
       "Perché questo prodotto"). wrapHeroMotivation non più usata (dead code).
     + Card secondarie: aggiunta la tagline-funzione sotto il nome.
     + Nota SPF: icona protezione solare (PNG Shopify CDN) a sinistra del testo,
       in entrambe le varianti aware/unaware. SVG evitato: non reso dai client email.
   v2.5.0 (6 giu 2026) — LAYOUT GERARCHICO CARD E1:
     ! buildProductsHtml: eroe (routine.heroProduct) a tutta larghezza in cima
       + testo "perché questo prodotto" subito sotto + altri 3 secondari (3-up
       desktop / impilati mobile, meno evidenza). Prima: griglia 2×2 con eroe
       hardcoded a core[1] e testo eroe in fondo a tutto (scollegato).
     ! Etichetta categoria: CREMA→"Crema viso", SIERI→"Siero viso" (i sieri
       prima mostravano lo stepLabel "Trattamento").
     ~ Il testo eroe (E1_P02_HERO) è spostato da buildE1 dentro buildProductsHtml.
       Intro/età/SPF/box sconto di E1 INVARIATI.
   v2.4.0 (6 giu 2026) — FIX CARD PRODOTTI E1 (placeholder annidato):
     ! buildE1 ora INLINA buildProductsHtml(routineCode, customer) al posto del
       literal '[contact:QUIZ_EMAIL_PRODUCTS_HTML {}]'. Causa del bug: Giotto fa
       sostituzione single-pass e non risolve un placeholder che compare dentro
       il valore di un altro campo iniettato (QUIZ_EMAIL_E1_HTML) → restava testo.
     ~ Le card E1 ora derivano da SKON_EMAIL.buildProductsHtml (single source of
       truth) invece che dal campo separato QUIZ_EMAIL_PRODUCTS_HTML del payload
       quiz.js (che diventa inutilizzato dal template — cleanup in TD).
     ~ buildProductsHtml e buildRoutineHtml INVARIATI; cambia solo l'output di buildE1
       (placeholder → card reali).
   v2.3.0 (6 giu 2026) — FIX CTA E4:
     ! buildRoutineHtml: la CTA "Vai alla mia routine" non punta più al PDP del
       detergente (core[0], il prodotto più debole) ma a /collections/catalogo,
       riusando l'helper _buildCtaUrl — stessa identica destinazione/parametri di
       E1. Lo spw_core nel link precarica comunque l'intera routine sul landing.
     - Rimossa la costruzione URL duplicata a mano (e la var profileLetter ora
       inutile). buildE1 e buildProductsHtml INVARIATI.
   v2.2.0 (6 giu 2026) — E4 NARRATIVO DA SkonRoutine:
     ! buildRoutineHtml(routineCode, customer) NON rende più 6/5 card-prodotto
       (che duplicavano la logica step), ma la narrativa mattino/sera verbatim
       Clio letta da SkonRoutine.get(code).morningRoutine / .eveningRoutine.
       Due blocchi (Mattino verde / Sera scuro) + CTA. Profilo D naturale.
     + Guard SkonRoutine alzato a ≥ v1.4.0 (richiede morningRoutine/eveningRoutine).
     ~ buildE1 e buildProductsHtml INVARIATI: verifica continuità 560 casi
       (28 routine × 5 età × 2 SPF × 2 nomi) → 0 differenze.
     · Deploy ATOMICO con logic-data v1.4.0 + skon-quiz.js v2.6.0.
   v2.1.0 (6 giu 2026) — RIALLINEAMENTO COPY E1 AL GOOGLE SHEET DI REVISIONE:
     ~ E1 ristrutturata sui testi del Google Sheet (tab Email E1):
       eyebrow, titolo, intro per-profilo (4 intro_clio_verbatim), note SPF,
       label prodotti, supporto+CTA sconto = verbatim Clio.
     + E1_INTRO_PROFILE (4): intro narrativa per profilo (sostituisce la
       vecchia diagnosi per desiderio×età E1_T01_DIAGNOSI/E1_T02_P2, rimosse).
     + E1_AGE_MODIFIER (3): modificatore per CLUSTER (giovane/matura/senior)
       — bozze ad-hoc in attesa di validazione Clio (erano TBD nel Sheet).
       Sostituisce E1_T03_NOTA_GIOVANE/E1_T04_NOTA_SENIOR (solo lt25/55plus).
     ~ Intro: mantenuto opener personalizzato 'Ci hai detto che vorresti …'
       (riusa E1_T01_APERTURE) + intro profilo Clio come 2° paragrafo.
     ~ E1_P02_HERO: MANTENUTI i testi ricchi del codice (più forti del
       placeholder descrizione-prodotto del Sheet) — da riportare nel Sheet.
     - Shim retrocompatibile e wrapper HTML INVARIATI (quiz.js non toccato).
     · E1_AGE_INTRO_MAP ora inutilizzato (resta definito, dead code innocuo).
   v2.0.0 (29 mag 2026) — REFACTOR ARCHITETTURALE:
     ! buildE1 cambia firma: ora (routineCode, customer) invece di
       (profile) — 10 campi → 2. Tutti i dati derivabili da routineCode
       (profileLetter, desire normalizzato, core, hero, intro) sono pescati
       da SkonRoutine.get(routineCode) e non passati come parametri.
       ⚠ SHIM RETROCOMPATIBILE: la vecchia firma buildE1({firstName,
       profileLetter, desire, age, interestSpf, coreIds, ...}) continua a
       funzionare. La nuova v2.0.0 rileva il vecchio shape (oggetto con
       'coreIds') e fa reverse lookup del routineCode via profileLetter + 
       firma dei coreIds. Garantisce zero rotture al deploy disgiunto da
       skon-quiz.js v3.0.0 (TD-1). Lo shim resterà finché TD-1 non sarà 
       chiuso, poi si potrà rimuovere (TODO: tracciare in v2.1.0).
       [AGGIORNAMENTO v2.10.0, 8 giu 2026: SHIM RIMOSSO — TD-8 chiuso in
       deploy atomico con skon-quiz.js v3.0.0 (TD-1). La vecchia firma NON è
       più supportata.]
     + Aggiunte buildProductsHtml(routineCode, customer) e
       buildRoutineHtml(routineCode, customer) — centralizzano la generazione
       delle card prodotti che skon-quiz.js v2.5.0 ha ancora duplicate.
       Output: HTML identico a quello di skon-quiz.js (verificato bit-per-bit
       a meno dei 7 fix nominali allineati a CATALOG live, v1.3.0 logic-data).
       Test diff bit-per-bit: 112/112 confronti IDENTICI (28 routine × 2 scenari
       NC/RC × 2 funzioni).
     - Rimossa dipendenza da AGE_BUCKET_MAP locale: ora si usa
       SkonRoutine.getAgeCluster() (stesso mapping, fonte autoritativa).
     - Rimossa dipendenza da E1_AGE_INTRO_MAP locale per la lookup intro
       (resta come dato statico — è copy email, non logica modello).
     + Dipendenza esplicita da SkonRoutine ≥ v1.3.0: usa getProductById()
       per recuperare AbraKadabra Glow/Matt nelle card "Protezione Solare"
       (8 routine — A5/A6/A9/B3/B4/D5/D6/D9 — non hanno akId nei core/tips
       della routine; serve la lookup "sciolta" introdotta in v1.3.0).
     ~ E1_T01_DIAGNOSI, E1_T02_P2, E1_P02_HERO, E1_S01_SPF_AWARE,
       E1_S02_SPF_UNAWARE: COPY INVARIATO bit-per-bit dalla v1.0.0. Verrà
       sostituito dopo validazione di Clio sull'Excel SKON_EMAIL_REVIEW.
   v1.0.0 (17 mag 2026): release iniziale, firma buildE1(profile).

   TO-DO APERTI (vedere TD-1, TD-2 in handoff sessione 29 mag pomeriggio)
   ──────────────────────────────────────────────────────────────────────────
   - TD-1: skon-quiz.js v3.0.0 deve sostituire le proprie buildEmail*Html
     interne con le chiamate a window.SKON_EMAIL.buildProductsHtml /
     buildRoutineHtml. DEPLOY ATOMICO obbligatorio con questo file.
   - TD-3: Excel revisione Clio (SKON_EMAIL_REVIEW) → versione 0.2 per
     marcare i 7 fix nominali applicati a SkonRoutine v1.2.0.
═══════════════════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ════════════════════════════════════════════════════════════════════════
     COSTANTI E1 — COPY EMAIL (invariato bit-per-bit da v1.0.0 — pre-Clio)
     ────────────────────────────────────────────────────────────────────────
     Marketing/Clio modificheranno questi testi via Excel di revisione +
     re-export. Non toccare manualmente: i testi qui devono restare allineati
     a un singolo file di verità (l'Excel di proposta versionato).
  ════════════════════════════════════════════════════════════════════════ */

  // ── E1-M01 — OGGETTO email ─────────────────────────────────────────────
  var E1_M01_OGGETTO = '{NOME}, ecco la tua routine Skön';

  // ── E1-M02 — PREVIEW TEXT ──────────────────────────────────────────────
  var E1_M02_PREVIEW = 'Il tuo protocollo personalizzato — con il codice riservato all\'interno';

  // ── E1-B01 — EYEBROW LABEL banda verde ─────────────────────────────────
  var E1_B01_EYEBROW = 'LA TUA ROUTINE PERSONALIZZATA';

  // ── E1-B02 — TITOLO banda verde ────────────────────────────────────────
  var E1_B02_TITOLO = 'Ciao {NOME}, ecco la tua routine.';

  // ── E1-T01 — APERTURE (riusata per l'opener personalizzato) ────────────
  // Frase neutra per desiderio: non rivela quale dei due desideri grezzi
  // (lev/for per A-B, lib/uni per C-D) ha scelto il lead.
  var E1_T01_APERTURE = {
    'A_lev': 'una pelle con più tono e densità',
    'A_for': 'una pelle forte e ben nutrita',
    'B_lev': 'una pelle con più tono e morbidezza al tatto',
    'B_for': 'una pelle forte e idratata',
    'C_lib': 'una pelle libera dalle imperfezioni',
    'C_uni': 'una pelle uniforme',
    'D_uni': 'una pelle uniforme e luminosa',
    'D_lev': 'una pelle con più tono e luminosità',
  };

  // ── E1-INTRO — Intro narrativa PER PROFILO (verbatim Clio, Sheet) ──────
  // 2° paragrafo dell'intro E1. Una per profilo A/B/C/D.
  var E1_INTRO_PROFILE = {
    'A': "Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle bella, sana e luminosa ✨ #TurnYourSkinÖn",
    'B': "Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle forte, morbida e idratata ✨ #TurnYourSkinÖn",
    'C': "Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle sana, uniforme e libera dalle imperfezioni ✨ #TurnYourSkinÖn",
    'D': "Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è caratterizzata da texture sensoriali e arricchita con principi attivi di origine naturale scelti per lavorare in sinergia garantendo massima efficacia e risultati visibili. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo per ritrovare una pelle uniforme e luminosa ✨ #TurnYourSkinÖn",
  };

  // ── E1-AGE — Modificatore PER CLUSTER (bozze Claude, TBD Clio) ─────────
  // giovane = lt25+25-35 · matura = 35-45+45-55 · senior = 55plus
  var E1_AGE_MODIFIER = {
    'giovane': "Alla tua età la pelle ha ancora una forte capacità di rigenerarsi: questo protocollo non corregge, accompagna. È il momento in cui la costanza rende di più — quello che fai adesso è ciò che la tua pelle ti restituirà tra dieci anni.",
    'matura':  "In questa fase la pelle cambia ritmo: produce meno collagene e trattiene meno acqua, ma risponde ancora bene agli attivi giusti. Il protocollo è calibrato per darle concentrazioni efficaci senza appesantirla — costanza più che intensità.",
    'senior':  "Dopo i 55 anni la pelle ha una storia fatta di sole, ormoni e tempo. Non le servono promesse «antietà», ma attivi ad alta concentrazione usati con regolarità. Questo protocollo è pensato per questo: precisione, non miracoli.",
  };

  // ── E1-S01 / S02 — Note SPF (verbatim Clio, Sheet) ─────────────────────
  var E1_S01_SPF_AWARE   = "La protezione solare quotidiana è il gesto antiaging con le prove scientifiche più solide. Continua così: è una delle cose che farà la differenza nel lungo periodo.";
  var E1_S02_SPF_UNAWARE = "C'è una cosa che ancora non ti abbiamo detto: la protezione solare quotidiana è l'unico gesto antiaging davvero efficace. I raggi UV passano dalle nuvole e dai vetri ogni giorno dell'anno. Vale la pena pensarci.";

  // ── E1-P01 — Label sezione prodotti (verbatim Clio, Sheet) ─────────────
  var E1_P01_LABEL_PRODOTTI = 'I prodotti della tua routine';
  // Icona protezione solare (PNG su Shopify CDN — SVG non è supportato dai client
  // email principali). 80x80 reali, mostrata a 40x40. Vuota = nessuna icona.
  var SPF_ICON_URL = 'https://cdn.shopify.com/s/files/1/0785/8756/0209/files/skon-spf-icon.png?v=1780775485';
  // Collection protezione solare: PATH usato da _buildCtaUrl per generare il
  // link con redirect-sconto (come tutte le CTA email), in fondo alla nota SPF.
  var SPF_COLLECTION_PATH = '/collections/protezione-solare';

  // ── E1-P02 — Motivazione hero (testi ricchi del codice, MANTENUTI) ─────
  // Chiave = id prodotto hero (calcolato da SkonRoutine.heroProduct).
  var E1_P02_HERO = {
    'better_late':        "Il Bakuchiol del Better Late Than Never stimola i fibroblasti a produrre più collagene. Non sostituisce il retinolo aggredendo la pelle: agisce con lo stesso meccanismo ma senza effetti collaterali.",
    'arctic_waterfalls':  "L'Acido Ialuronico a tre pesi molecolari di Arctic Waterfalls raggiunge tre livelli cutanei diversi: la superficie idrata immediatamente, lo strato intermedio rimpolpa nel medio termine, lo strato profondo lavora sulla densità della pelle.",
    'bakuplex_serum':     "Il complesso Bakuplex® — brevetto Skön che unisce Bakuchiol, Vitamina E e Orizanolo — è un'alternativa al retinolo pensata per pelli mature: stimola il rinnovamento cellulare e contrasta i segni del tempo senza aggredire.",
    'siero_imperfezioni': "Il Pimple Potion contiene Acido Salicilico liposolubile: penetra nel follicolo pilosebaceo, scioglie il sebo congestionato e libera il poro dall'interno, senza l'effetto rebound dei trattamenti aggressivi.",
    'vitamin_blast':      "La Vitamina C stabilizzata di Vitamin Blast neutralizza i radicali liberi prima che danneggino il collagene, e stimola la sintesi di nuovo collagene. Effetto antiossidante e uniformante in un solo prodotto.",
  };

  // ── E1-C01 / C02 / C03 — Box sconto (C02/C03 verbatim Clio, Sheet) ─────
  var E1_C01_LABEL_SCONTO = 'IL TUO CODICE SCONTO RISERVATO';
  var E1_C02_TESTO_SCONTO = "Usa il codice al checkout — è riservato al tuo profilo e vale sul primo ordine.";
  var E1_C03_CTA          = 'Vai alla mia routine';

  // ── Fallback intro per combinazioni inattese ───────────────────────────
  var E1_FALLBACK_INTRO = "Abbiamo creato per te una skincare routine completa, pensata per accompagnarti dalla detersione al trattamento. Ogni formula è arricchita con principi attivi di origine naturale scelti per lavorare in sinergia. È un percorso che invita a rallentare e ritagliarti un momento tutto tuo ✨ #TurnYourSkinÖn";


  /* ════════════════════════════════════════════════════════════════════════
     MAPPING DI SERVIZIO — utility locali per E1
  ════════════════════════════════════════════════════════════════════════ */

  // Età grezza → stringa preposizionata per intro P1
  var E1_AGE_INTRO_MAP = {
    'lt25':   'A meno di 25 anni',
    '25-35':  'Tra i 25 e i 35 anni',
    '35-45':  'Tra i 35 e i 45 anni',
    '45-55':  'Tra i 45 e i 55 anni',
    '55plus': 'Dopo i 55 anni',
  };

  // Desiderio grezzo quiz → chiave breve narrativa.
  // levigata_rimpolpata e tonica_elastica condividono narrativa 'lev'
  // (wording neutro evita di rivelare quale dei due ha scelto il lead).
  // NB: il quiz oggi mappa il desire grezzo come stringa nel formato sopra.
  // Se SkonRoutine in futuro esporrà un 'desire_normalized', usare quello.
  var DESIRE_KEY_MAP = {
    'levigata_rimpolpata': 'lev',
    'tonica_elastica':     'lev',
    'forte_morbida':       'for',
    'libera_imperfezioni': 'lib',
    'uniforme_luminosa':   'uni',
  };

  // Profilo → desideri ammessi (per derivare la chiave pdKey).
  // Derivato dalla composizione delle 28 routine: ogni profilo ammette 1 o 2
  // desideri reali nei lookup. Se in futuro questo dato vivrà in SkonRoutine,
  // sostituire questa mappa con la lookup dal modello.
  var PROFILE_DESIRES = {
    'A': ['lev', 'for'],
    'B': ['lev', 'for'],
    'C': ['lib', 'uni'],
    'D': ['lev', 'uni'],
  };


  /* ════════════════════════════════════════════════════════════════════════
     GUARD — verifica SkonRoutine caricato
  ════════════════════════════════════════════════════════════════════════ */

  function _checkSkonRoutine() {
    if (typeof window === 'undefined' || !window.SkonRoutine ||
        typeof window.SkonRoutine.get !== 'function') {
      if (window.console && window.console.warn) {
        window.console.warn('[SKON_EMAIL] window.SkonRoutine non disponibile — ' +
          'verificare caricamento skon-quiz-logic-data.js v1.2.0+ prima di ' +
          'questo file. Le funzioni email ritorneranno stringa vuota.');
      }
      return false;
    }
    var ver = window.SkonRoutine.version || '0.0.0';
    var major = parseInt(ver.split('.')[0], 10);
    var minor = parseInt(ver.split('.')[1], 10);
    if (major < 1 || (major === 1 && minor < 4)) {
      if (window.console && window.console.warn) {
        window.console.warn('[SKON_EMAIL] window.SkonRoutine v' + ver +
          ' troppo vecchio (richiede ≥ 1.4.0 per morningRoutine/eveningRoutine ' +
          'oltre a heroProduct, imgs, stepLabel, getProductById). HARD FAIL — le ' +
          'funzioni email ritorneranno stringa vuota. Probabile cache CDN durante ' +
          'propagazione deploy: aspettare 1-2 min e force-reload, oppure verificare ' +
          'deploy di skon-quiz-logic-data.js v1.4.0.');
      }
      return false;
      // Hard fail invece di warn-and-proceed: in v1.0.0/1.1.0 mancano i campi
      // heroProduct, imgs, stepLabel — buildE1/buildProductsHtml crasherebbero a
      // 'Cannot read property X of undefined' producendo email rotte silenti.
      // Meglio email vuote (rilevabili dal Worker check + monitoring Magnews)
      // che JS errors silenti che producono HTML malformato.
    }
    return true;
  }


  /* ════════════════════════════════════════════════════════════════════════
     HELPER — composizione HTML per Magnews maincontent E1
     ────────────────────────────────────────────────────────────────────────
     Wrapper HTML INVARIATI bit-per-bit dalla v1.0.0. Sono pattern email-safe
     (table-based, inline style) testati con Magnews/Giotto. Non toccare
     senza testare il rendering reale nel client di Magnews.
  ════════════════════════════════════════════════════════════════════════ */

  // Banda verde con eyebrow + titolo personalizzato
  function wrapBandaVerde(eyebrow, titolo) {
    return '<table class="sectionOuter responsive" width="100%" cellspacing="0" cellpadding="0" border="0" role="none">'
      + '<tbody><tr><td>'
      + '<table class="sectionInner" width="660" align="center" style="background-color:#1f5842;" cellspacing="0" cellpadding="0" border="0" role="none">'
      + '<tbody><tr>'
      + '<td class="col col-left col-right" width="660" style="vertical-align:middle;">'
      + '<table width="100%" cellspacing="0" cellpadding="0" border="0" role="none"><tbody><tr>'
      + '<td class="padY-xl padYb-xl padX-48">'
      + '<p style="margin:0 0 8px 0;font-family:\'Trebuchet MS\',Arial,sans-serif;font-size:11px;font-weight:bold;letter-spacing:2.5px;color:#a8d4be;text-transform:uppercase;line-height:1.2;">'
      + eyebrow
      + '</p>'
      + '<h1 class="title-2" style="font-family:\'Trebuchet MS\',Arial,sans-serif;font-size:28px;line-height:34px;font-weight:bold;color:#ffffff;letter-spacing:-0.5px;margin:0;">'
      + titolo
      + '</h1>'
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>';
  }

  // Paragrafi intro P1 + P2
  function wrapIntroParagraphs(p1, p2) {
    return '<table class="sectionOuter responsive" width="100%" cellspacing="0" cellpadding="0" border="0" role="none">'
      + '<tbody><tr><td>'
      + '<table class="sectionInner" width="660" align="center" style="background-color:#ffffff;" cellspacing="0" cellpadding="0" border="0" role="none">'
      + '<tbody><tr>'
      + '<td class="col col-left col-right" width="660">'
      + '<table width="100%" cellspacing="0" cellpadding="0" border="0" role="none"><tbody><tr>'
      + '<td class="padY-xl padYb-m padX-48">'
      + '<div class="text font-size-m after-m" style="color:#575757;">'
      + '<p style="margin:0 0 14px 0;">' + p1 + '</p>'
      + '<p style="margin:0;">' + p2 + '</p>'
      + '</div>'
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>';
  }

  // Nota età (lt25 o 55plus) — box verde chiaro con bordo sinistro
  function wrapAgeNote(text) {
    return '<table class="sectionOuter responsive" width="100%" cellspacing="0" cellpadding="0" border="0" role="none">'
      + '<tbody><tr><td>'
      + '<table class="sectionInner" width="660" align="center" style="background-color:#ffffff;" cellspacing="0" cellpadding="0" border="0" role="none">'
      + '<tbody><tr>'
      + '<td class="col col-left col-right" width="660">'
      + '<table width="100%" cellspacing="0" cellpadding="0" border="0" role="none"><tbody><tr>'
      + '<td class="padY-xs padYb-xs padX-48">'
      + '<table class="sub-cols col-left col-right" width="100%" style="background-color:#f0f7f3;border-radius:0;border-left:3px solid #1f5842;" cellspacing="0" cellpadding="0" border="0" role="none">'
      + '<tbody><tr><td class="padY-m padYb-m padX-24">'
      + '<div class="text font-size-s" style="color:#1f5842;font-style:italic;">'
      + text
      + '</div>'
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>';
  }

  // Nota SPF — 2 stili: aware (verde, con check) o unaware (arancione, label)
  // Avvolge il contenuto della nota SPF con l'icona a sinistra (2 colonne).
  // Se SPF_ICON_URL è vuoto, ritorna il contenuto invariato.
  function _withSpfIcon(inner) {
    if (!SPF_ICON_URL) return inner;
    return '<table width="100%" cellspacing="0" cellpadding="0" border="0" role="none"><tbody><tr>'
      + '<td width="54" style="vertical-align:top;padding-right:14px;">'
      + '<img src="' + SPF_ICON_URL + '" width="40" height="40" alt="Protezione solare" style="display:block;width:40px;height:40px;">'
      + '</td>'
      + '<td style="vertical-align:top;">' + inner + '</td>'
      + '</tr></tbody></table>';
  }

  // Link alla collection protezione solare in fondo alla nota SPF.
  // L'URL arriva già pronto da _buildCtaUrl (redirect con sconto applicato),
  // come tutte le CTA email. Colore per variante (verde aware / arancione unaware).
  function _spfLink(color, url) {
    return '<p style="margin:12px 0 0 0;font-family:Arial,sans-serif;font-size:13px;font-weight:700;">'
      + '<a href="' + url + '" style="color:' + color + ';text-decoration:underline;">Scopri la protezione solare Skön &#8594;</a>'
      + '</p>';
  }

  function wrapSpfNote(text, isAware, spfUrl) {
    if (isAware) {
      return '<table class="sectionOuter responsive" width="100%" cellspacing="0" cellpadding="0" border="0" role="none">'
        + '<tbody><tr><td>'
        + '<table class="sectionInner" width="660" align="center" style="background-color:#ffffff;" cellspacing="0" cellpadding="0" border="0" role="none">'
        + '<tbody><tr>'
        + '<td class="col col-left col-right" width="660">'
        + '<table width="100%" cellspacing="0" cellpadding="0" border="0" role="none"><tbody><tr>'
        + '<td class="padY-m padYb-xl padX-48">'
        + '<table class="sub-cols col-left col-right borderfull" width="100%" style="background-color:#f0f7f3;border:1px solid #1f5842;border-radius:24px;" cellspacing="0" cellpadding="0" border="0" role="none">'
        + '<tbody><tr><td class="padY-m padYb-m padX-24">'
        + _withSpfIcon('<div class="text font-size-s" style="color:#1f5842;">' + text + '</div>' + _spfLink('#1f5842', spfUrl))
        + '</td></tr></tbody></table>'
        + '</td></tr></tbody></table>'
        + '</td></tr></tbody></table>'
        + '</td></tr></tbody></table>';
    }
    // Variante unaware — arancione con label
    return '<table class="sectionOuter responsive" width="100%" cellspacing="0" cellpadding="0" border="0" role="none">'
      + '<tbody><tr><td>'
      + '<table class="sectionInner" width="660" align="center" style="background-color:#ffffff;" cellspacing="0" cellpadding="0" border="0" role="none">'
      + '<tbody><tr>'
      + '<td class="col col-left col-right" width="660">'
      + '<table width="100%" cellspacing="0" cellpadding="0" border="0" role="none"><tbody><tr>'
      + '<td class="padY-m padYb-xl padX-48">'
      + '<table class="sub-cols col-left col-right" width="100%" style="background-color:#fff8f0;border-radius:0;border-left:4px solid #f07030;" cellspacing="0" cellpadding="0" border="0" role="none">'
      + '<tbody><tr><td class="padY-m padYb-m padX-24">'
      + _withSpfIcon(
          '<p style="margin:0 0 6px 0;font-family:\'Trebuchet MS\',Arial,sans-serif;font-size:11px;font-weight:bold;color:#f07030;letter-spacing:1.5px;text-transform:uppercase;">'
          + 'Una cosa che non ti abbiamo ancora detto'
          + '</p>'
          + '<div class="text font-size-s" style="color:#575757;">'
          + text
          + '</div>'
          + _spfLink('#f07030', spfUrl)
        )
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>';
  }

  // Label sezione prodotti (sfondo crema, testo verde, bordo)
  function wrapProductsLabel(labelText) {
    return '<table class="sectionOuter responsive" width="100%" cellspacing="0" cellpadding="0" border="0" role="none">'
      + '<tbody><tr><td>'
      + '<table class="sectionInner" width="660" align="center" cellspacing="0" cellpadding="0" border="0" role="none" style="background-color:#f5f5f2;">'
      + '<tbody><tr>'
      + '<td class="col col-left col-right padY-m padYb-xs padX-48" width="660">'
      + '<p style="margin:0;font-size:10px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#1f5842;text-align:center;border-bottom:1px solid #1f5842;padding-bottom:10px;">'
      + labelText
      + '</p>'
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>';
  }

  // Motivazione prodotto hero — testo singolo dopo la sezione card prodotti
  function wrapHeroMotivation(text) {
    if (!text) return '';
    return '<table class="sectionOuter responsive" width="100%" cellspacing="0" cellpadding="0" border="0" role="none">'
      + '<tbody><tr><td>'
      + '<table class="sectionInner" width="660" align="center" style="background-color:#ffffff;" cellspacing="0" cellpadding="0" border="0" role="none">'
      + '<tbody><tr>'
      + '<td class="col col-left col-right" width="660">'
      + '<table width="100%" cellspacing="0" cellpadding="0" border="0" role="none"><tbody><tr>'
      + '<td class="padY-m padYb-m padX-48">'
      + '<p style="margin:0 0 8px 0;font-family:\'Trebuchet MS\',Arial,sans-serif;font-size:11px;font-weight:bold;color:#1f5842;letter-spacing:1.5px;text-transform:uppercase;">'
      + 'Perché questo prodotto'
      + '</p>'
      + '<div class="text font-size-s" style="color:#575757;">'
      + text
      + '</div>'
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>';
  }

  // Box sconto verde con codice + CTA arancione
  function wrapBoxSconto(labelSconto, testoSconto, discountCode, ctaText, ctaUrl) {
    return '<table class="sectionOuter responsive" width="100%" cellspacing="0" cellpadding="0" border="0" role="none">'
      + '<tbody><tr><td>'
      + '<table class="sectionInner" width="660" align="center" style="background-color:#1f5842;" cellspacing="0" cellpadding="0" border="0" role="none">'
      + '<tbody><tr>'
      + '<td class="col col-left col-right" width="660">'
      + '<table width="100%" cellspacing="0" cellpadding="0" border="0" role="none"><tbody><tr>'
      + '<td class="padY-xl padYb-xl padX-48" style="text-align:center;">'
      + '<p style="margin:0 0 10px 0;font-family:\'Trebuchet MS\',Arial,sans-serif;font-size:11px;font-weight:bold;letter-spacing:2.5px;color:#a8d4be;text-transform:uppercase;line-height:1.2;">'
      + labelSconto
      + '</p>'
      + '<div class="text font-size-m after-l" style="color:#ffffff;max-width:460px;margin:0 auto 10px auto;">'
      + testoSconto
      + '</div>'
      + '<table cellspacing="0" cellpadding="0" border="0" role="none" style="margin:0 auto 22px auto;">'
      + '<tbody><tr>'
      + '<td style="border:2px dashed #a8d4be;border-radius:8px;padding:8px 28px;text-align:center;">'
      + '<p style="margin:0 0 4px 0;font-size:11px;font-weight:bold;letter-spacing:1.5px;text-transform:uppercase;color:#a8d4be;">Usa il codice sconto:</p>'
      + '<p style="margin:0;font-size:28px;font-weight:900;letter-spacing:4px;color:#ffffff;font-family:\'Courier New\',Courier,monospace;">'
      + discountCode
      + '</p>'
      + '</td>'
      + '</tr></tbody></table>'
      + '<table cellspacing="0" cellpadding="0" border="0" role="none" style="margin:0 auto;">'
      + '<tbody><tr>'
      + '<td class="button button-default after-0">'
      + '<a href="' + ctaUrl + '" class="button-m" style="color:#ffffff;background-color:#f07030;border:2px solid #f07030;border-radius:40px;display:block;text-decoration:none;text-align:center;font-weight:bold;font-family:\'Trebuchet MS\',Arial,sans-serif;font-size:16px;line-height:24px;padding:11px 32px;mso-border-alt:none;word-break:keep-all;box-sizing:border-box;">'
      + ctaText
      + '</a>'
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>'
      + '</td></tr></tbody></table>';
  }


  /* ════════════════════════════════════════════════════════════════════════
     CTA URL builder — pattern univoco per tutti i link sconto delle email
     ────────────────────────────────────────────────────────────────────────
     Genera: https://skoncosmetics.com/discount/<CODE>?redirect=<PATH>
                                       &spw_core=<csv>&spw_name=<urlenc>
                                       &spw_pct=<int>&spw_profile=<L>&spw_rc=<bool>
  ════════════════════════════════════════════════════════════════════════ */
  function _buildCtaUrl(redirectPath, customer, routine) {
    var coreIds = routine.core.map(function(p) { return p.id; });
    return 'https://skoncosmetics.com/discount/' + customer.discountCode
      + '?redirect=' + redirectPath
      + '&spw_core=' + coreIds.join(',')
      + '&spw_name=' + encodeURIComponent(customer.name || '')
      + '&spw_pct='  + (customer.discountPct || 15)
      + '&spw_profile=' + routine.profileLetter
      + '&spw_rc=' + (customer.isRC ? 'true' : 'false');
  }


  /* ════════════════════════════════════════════════════════════════════════
     buildE1(routineCode, customer)  →  HTML maincontent E1
     ────────────────────────────────────────────────────────────────────────
     customer: { name, age, spfInterest, discountCode, discountPct, isRC }
       - name        : string (può essere vuoto, fallback "tu" nel rendering)
       - age         : 'lt25'|'25-35'|'35-45'|'45-55'|'55plus'
       - spfInterest : boolean (true = aware)
       - discountCode: string
       - discountPct : int (es. 15, 25, 30, 50)
       - isRC        : boolean
     Output: stringa HTML pronta per Magnews QUIZ_EMAIL_E1_HTML.
     v2.4.0: il blocco card prodotti è INLINE qui (buildProductsHtml). Prima era
     un placeholder Giotto [contact:QUIZ_EMAIL_PRODUCTS_HTML] annidato dentro
     questo stesso campo: Giotto NON ri-scansiona i placeholder dentro un campo
     già iniettato (sostituzione single-pass), quindi restava testo letterale.
     Inlinando, il template Magnews deve contenere solo [contact:QUIZ_EMAIL_E1_HTML].
  ════════════════════════════════════════════════════════════════════════ */
  function buildE1(routineCode, customer) {
    if (!_checkSkonRoutine()) return '';

    customer = customer || {};

    var routine = window.SkonRoutine.get(routineCode);
    if (!routine) {
      if (window.console && window.console.warn) {
        window.console.warn('[SKON_EMAIL] buildE1: routineCode "' + routineCode + '" non trovato.');
      }
      return '';
    }

    // ── Risoluzione chiavi narrative ──
    var ageBucket  = window.SkonRoutine.getAgeCluster(customer.age) || 'matura';
    var desireKey  = DESIRE_KEY_MAP[customer.desire]               || _inferDesireKey(routine.profileLetter, customer);
    var profileLet = routine.profileLetter;
    var pdKey      = profileLet + '_' + desireKey;

    // ── Pesca testi (v2.1.0 — struttura allineata al Google Sheet) ──
    var aperturaPhrase = E1_T01_APERTURE[pdKey]       || '';
    var profileIntro   = E1_INTRO_PROFILE[profileLet] || E1_FALLBACK_INTRO;

    // ── Intro: opener personalizzato per-desiderio + intro profilo (Clio) ──
    var p1, p2;
    if (aperturaPhrase) {
      p1 = 'Ci hai detto che vorresti ' + aperturaPhrase + '.';
      p2 = profileIntro;
    } else {
      p1 = profileIntro;
      p2 = '';
    }

    // ── Titolo (nome vuoto: "Ciao {NOME}, …" → "Ciao, …") ──
    var titolo = customer.name
      ? E1_B02_TITOLO.replace('{NOME}', customer.name)
      : E1_B02_TITOLO.replace('Ciao {NOME},', 'Ciao,');

    // ── Modificatore età per CLUSTER (giovane/matura/senior) ──
    var notaEta = E1_AGE_MODIFIER[ageBucket] || '';

    // ── Nota SPF ──
    var notaSpfText = customer.spfInterest ? E1_S01_SPF_AWARE : E1_S02_SPF_UNAWARE;

    // ── CTA URL (redirect alla collection catalogo) ──
    var ctaUrl = _buildCtaUrl('/collections/catalogo', customer, routine);

    // ── Composizione HTML finale ──
    return wrapBandaVerde(E1_B01_EYEBROW, titolo) +
           wrapIntroParagraphs(p1, p2) +
           (notaEta ? wrapAgeNote(notaEta) : '') +
           wrapProductsLabel(E1_P01_LABEL_PRODOTTI) +
           buildProductsHtml(routineCode, customer) +
           wrapSpfNote(notaSpfText, !!customer.spfInterest, _buildCtaUrl(SPF_COLLECTION_PATH, customer, routine)) +
           wrapBoxSconto(
             E1_C01_LABEL_SCONTO,
             E1_C02_TESTO_SCONTO,
             customer.discountCode || '',
             E1_C03_CTA,
             ctaUrl
           );
  }

  // Inferenza fallback del desire key quando customer.desire non è esplicito.
  // Usa il primo desire ammesso dal profilo. Sopravvive a chiamate "leggere"
  // che non passano il desire (es. tool di test).
  function _inferDesireKey(profileLetter, customer) {
    if (customer.desire) {
      return DESIRE_KEY_MAP[customer.desire] || (PROFILE_DESIRES[profileLetter] || ['lev'])[0];
    }
    return (PROFILE_DESIRES[profileLetter] || ['lev'])[0];
  }


  /* ════════════════════════════════════════════════════════════════════════
     buildProductsHtml(routineCode, customer)  →  HTML 4 card prodotti per E1
     ────────────────────────────────────────────────────────────────────────
     v2.5.0: layout gerarchico. L'EROE (routine.heroProduct, single source of
     truth — non più l'hardcoded core[1]) è una card a TUTTA LARGHEZZA in cima,
     con banner + il testo "perché questo prodotto" (E1_P02_HERO) SUBITO SOTTO.
     Gli altri 3 prodotti seguono come card secondarie meno evidenti (3-up su
     desktop, impilate su mobile via classe .col-product). Etichetta categoria:
     CREMA→"Crema viso", SIERI→"Siero viso". Il testo eroe è ora reso QUI (prima
     era in coda a buildE1). Inlineato in QUIZ_EMAIL_E1_HTML (v2.4.0).

     customer: { name, discountCode, discountPct, isRC }
  ════════════════════════════════════════════════════════════════════════ */
  function buildProductsHtml(routineCode, customer) {
    if (!_checkSkonRoutine()) return '';
    customer = customer || {};

    var routine = window.SkonRoutine.get(routineCode);
    if (!routine) return '';

    var core = routine.core || [];
    var hero = routine.heroProduct || (core.length ? core[0] : null);
    var heroId = hero ? hero.id : null;
    var others = core.filter(function(p) { return p && p.id !== heroId; });
    var heroText = (heroId && E1_P02_HERO[heroId]) ? E1_P02_HERO[heroId] : '';
    var heroEyebrow = 'Perché è ideale per te' + (customer.name ? ', ' + customer.name : '');

    function urlFor(p) {
      return 'https://skoncosmetics.com/discount/' + customer.discountCode
        + '?redirect=/products/' + p.handle
        + '&spw_core=' + core.map(function(x) { return x.id; }).join(',')
        + '&spw_name=' + encodeURIComponent(customer.name || '')
        + '&spw_pct=' + (customer.discountPct || 15)
        + '&spw_profile=' + routine.profileLetter
        + '&spw_rc=' + (customer.isRC ? 'true' : 'false');
    }
    // Etichetta categoria mostrata sulla card: "Crema viso" / "Siero viso",
    // altrimenti lo stepLabel (Detersione, Contorno occhi, ...).
    function catLabel(p) {
      if (p.category === 'CREMA') return 'Crema viso';
      if (p.category === 'SIERI') return 'Siero viso';
      return p.stepLabel || '';
    }

    // ── HERO: card a tutta larghezza (banner + immagine + info + CTA) ──
    var heroCard = '';
    if (hero) {
      var hUrl = urlFor(hero);
      heroCard =
        '<table class="sectionInner" width="660" align="center" cellspacing="0" cellpadding="0" border="0" role="none" style="background-color:#f5f5f2;">'
        + '<tbody><tr><td style="padding:8px 8px 0 8px;">'
        + '<table width="100%" cellspacing="0" cellpadding="0" border="0" role="none" style="border:2px solid #1f5842;border-radius:12px;overflow:hidden;background:#ffffff;">'
        + '<tbody>'
        + '<tr><td style="background:#1f5842;padding:8px 16px;text-align:center;">'
        + '<span style="font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#ffffff;font-family:Arial,sans-serif;">&#9733; IL TRATTAMENTO PER LA TUA PELLE</span>'
        + '</td></tr>'
        + '<tr><td style="padding:0;"><a href="' + hUrl + '" style="text-decoration:none;display:block;">'
        + '<img src="' + (hero.imgs && hero.imgs[0] ? hero.imgs[0] : '') + '" width="656" height="260" alt="' + hero.name + '" style="display:block;width:100%;height:260px;object-fit:cover;">'
        + '</a></td></tr>'
        + '<tr><td style="padding:18px 24px 22px;text-align:center;">'
        + '<p style="margin:0 0 3px 0;font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#1f5842;font-family:Arial,sans-serif;">' + catLabel(hero) + '</p>'
        + '<p style="margin:0 0 6px 0;font-size:10px;font-weight:400;color:#999999;letter-spacing:0.8px;text-transform:uppercase;font-family:Arial,sans-serif;">' + (hero.shortDescription || '') + '</p>'
        + '<h3 style="font-size:20px;font-weight:700;color:#1C1C1A;margin:0 0 8px 0;line-height:1.3;font-family:Arial,sans-serif;">' + hero.name + '</h3>'
        + (hero.tagline ? '<p style="font-size:13px;color:#575757;margin:0 0 14px 0;line-height:1.5;font-family:Arial,sans-serif;">' + hero.tagline + '</p>' : '')
        + (heroText
            ? '<hr style="border:none;border-top:1px solid #e8e8e8;margin:8px 0 12px 0;">'
              + '<p style="margin:0 0 6px 0;font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#1f5842;font-family:Arial,sans-serif;">' + heroEyebrow + '</p>'
              + '<p style="margin:0 0 16px 0;font-size:13px;color:#575757;line-height:1.6;font-family:Arial,sans-serif;text-align:left;">' + heroText + '</p>'
            : '')
        + '<a href="' + hUrl + '" style="display:inline-block;background:#1f5842;color:#ffffff;font-size:13px;font-weight:700;text-decoration:none;padding:11px 28px;border-radius:50px;font-family:Arial,sans-serif;">Scopri &#8594;</a>'
        + '</td></tr>'
        + '</tbody></table>'
        + '</td></tr></tbody></table>';
    }

    // ── SECONDARI: gli altri 3, 3-up desktop / impilati mobile, meno evidenza ──
    // (immagine più piccola, tagline-funzione sotto il nome, CTA come link testuale).
    // Lo stacking mobile dipende dalla media query del template sulla classe
    // .col-product (stessa usata finora per la griglia 2×2).
    function secCard(p) {
      if (!p) return '';
      var u = urlFor(p);
      return '<td class="col-product" width="33.33%" style="vertical-align:top;padding:6px;">'
        + '<table width="100%" cellspacing="0" cellpadding="0" border="0" role="none" style="border:1px solid #e8e8e8;border-radius:10px;overflow:hidden;background:#ffffff;">'
        + '<tbody>'
        + '<tr><td style="padding:0;"><a href="' + u + '" style="text-decoration:none;display:block;">'
        + '<img src="' + (p.imgs && p.imgs[0] ? p.imgs[0] : '') + '" width="210" height="140" alt="' + p.name + '" style="display:block;width:100%;height:140px;object-fit:cover;">'
        + '</a></td></tr>'
        + '<tr><td style="padding:12px 12px 14px;">'
        + '<p style="margin:0 0 3px 0;font-size:9px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#1f5842;font-family:Arial,sans-serif;">' + catLabel(p) + '</p>'
        + '<h4 style="font-size:13px;font-weight:700;color:#1C1C1A;margin:0 0 6px 0;line-height:1.3;font-family:Arial,sans-serif;">' + p.name + '</h4>'
        + (p.tagline ? '<p style="margin:0 0 8px 0;font-size:11px;color:#575757;line-height:1.45;font-family:Arial,sans-serif;">' + p.tagline + '</p>' : '')
        + '<a href="' + u + '" style="font-size:11px;font-weight:700;color:#1f5842;text-decoration:underline;font-family:Arial,sans-serif;">Scopri &#8594;</a>'
        + '</td></tr>'
        + '</tbody></table></td>';
    }
    var secCells = others.map(secCard).join('');
    var secondary = secCells
      ? '<table class="sectionInner" width="660" align="center" cellspacing="0" cellpadding="0" border="0" role="none" style="background-color:#f5f5f2;">'
        + '<tbody><tr>' + secCells + '</tr></tbody></table>'
      : '';

    // Ordine: card eroe → "perché questo prodotto" (testo eroe) → gli altri 3.
    return heroCard
      + secondary;
  }


  /* ════════════════════════════════════════════════════════════════════════
     buildRoutineHtml(routineCode, customer)  →  HTML narrativa routine E4
     ────────────────────────────────────────────────────────────────────────
     v2.2.0: rende la narrativa mattino/sera verbatim Clio letta da
     SkonRoutine.get(code).morningRoutine / .eveningRoutine (single source of
     truth, richiede logic-data >= v1.4.0). Due blocchi (Mattino verde / Sera
     scuro) + CTA. Profilo D gestito naturalmente (la narrativa sera e' piu'
     breve). Sostituisce il vecchio rendering a 6/5 card-prodotto (che duplicava
     la logica step in questo consumer). Output: campo Magnews QUIZ_EMAIL_ROUTINE_HTML.
  ════════════════════════════════════════════════════════════════════════ */
  function buildRoutineHtml(routineCode, customer) {
    if (!_checkSkonRoutine()) return '';
    customer = customer || {};

    var routine = window.SkonRoutine.get(routineCode);
    if (!routine) return '';

    var morning = routine.morningRoutine || '';
    var evening = routine.eveningRoutine || '';
    // Nessuna narrativa (non deve accadere con SkonRoutine >= 1.4.0): ritorna
    // stringa vuota invece di un blocco vuoto, cosi il Worker/monitoring lo rileva.
    if (!morning && !evening) {
      if (window.console && window.console.warn) {
        window.console.warn('[SKON_EMAIL] buildRoutineHtml: nessuna narrativa ' +
          'mattino/sera per "' + routineCode + '". Verificare SkonRoutine >= v1.4.0.');
      }
      return '';
    }

    var core0 = (routine.core && routine.core[0]) ? routine.core[0] : null;

    // CTA: stesso helper e stessa destinazione di E1 (/collections/catalogo).
    // Lo spw_core precarica l'intera routine sul landing: non si atterra piu'
    // sul detergente core[0] (fix v2.3.0).
    var ctaUrl = _buildCtaUrl('/collections/catalogo', customer, routine);

    function block(moment, color, text) {
      if (!text) return '';
      return '<tr><td style="padding:6px 0;">'
        + '<table width="100%" cellspacing="0" cellpadding="0" border="0" role="none"'
        + ' style="border:1px solid #e8e8e8;border-radius:12px;background:#ffffff;overflow:hidden;">'
        + '<tr><td style="background:' + color + ';padding:10px 18px;">'
        + '<span style="font-size:11px;font-weight:700;letter-spacing:2px;'
        + 'text-transform:uppercase;color:#ffffff;font-family:Arial,sans-serif;">'
        + moment + '</span></td></tr>'
        + '<tr><td style="padding:16px 18px;">'
        + '<p style="margin:0;font-size:14px;color:#333333;line-height:1.7;'
        + 'font-family:Arial,sans-serif;">' + text + '</p>'
        + '</td></tr></table></td></tr>';
    }

    var header = '<tr><td style="padding:20px 0 12px 0;text-align:center;">'
      + '<h3 style="margin:0;font-size:18px;font-weight:700;color:#1f5842;'
      + 'letter-spacing:0.5px;font-family:Arial,sans-serif;">Come usare la tua routine</h3>'
      + '<p style="margin:6px 0 0 0;font-size:12px;color:#575757;font-family:Arial,sans-serif;">'
      + 'I gesti, passo dopo passo: mattino e sera.'
      + '</p></td></tr>';

    var blocks = block('Mattino', '#1f5842', morning)
               + block('Sera', '#1C1C1A', evening);

    var cta = '';
    if (core0) {
      cta = '<tr><td style="padding:18px 0 24px 0;text-align:center;">'
        + '<a href="' + ctaUrl + '" style="display:inline-block;background:#f07030;'
        + 'color:#ffffff;text-decoration:none;font-family:Arial,sans-serif;font-size:14px;'
        + 'font-weight:700;letter-spacing:0.5px;padding:14px 32px;border-radius:8px;">'
        + 'Vai alla mia routine</a></td></tr>';
    }

    return '<table class="sectionInner" width="660" align="center" cellspacing="0" cellpadding="0"'
      + ' border="0" role="none" style="background-color:#f5f5f2;padding:0 20px;">'
      + '<tbody>' + header + blocks + cta + '</tbody></table>';
  }


  /* ════════════════════════════════════════════════════════════════════════
     EXPORT — window.SKON_EMAIL
  ════════════════════════════════════════════════════════════════════════ */

  window.SKON_EMAIL = window.SKON_EMAIL || {};
  window.SKON_EMAIL.buildE1            = buildE1;
  window.SKON_EMAIL.buildProductsHtml  = buildProductsHtml;
  window.SKON_EMAIL.buildRoutineHtml   = buildRoutineHtml;
  window.SKON_EMAIL.version            = '2.10.0';

  // Metadati E1 (oggetto + preview) — esposti per uso lato quiz JS o tracking
  window.SKON_EMAIL.E1_META = {
    oggetto: E1_M01_OGGETTO,
    preview: E1_M02_PREVIEW,
  };

  // Debug: espone le costanti per testing manuale da console
  if (typeof window !== 'undefined' && window.console) {
    window.SKON_EMAIL._E1_DEBUG = {
      APERTURE:      E1_T01_APERTURE,
      INTRO_PROFILE: E1_INTRO_PROFILE,
      AGE_MODIFIER:  E1_AGE_MODIFIER,
      HERO:          E1_P02_HERO,
      DESIRE_KEY: DESIRE_KEY_MAP,
      PROFILE_DESIRES: PROFILE_DESIRES,
    };
  }

})();